import { useRef } from 'react';
import { useDialog } from 'react-aria';

import styles from './PopoverDialog.module.scss';

const PopoverDialog = ({ children, ...props }) => {
    const ref = useRef();
    const { dialogProps } = useDialog(props, ref);

    return (
        <div
            {...dialogProps}
            ref={ref}
            className={styles.dialog}
            data-testid={props['data-testid'] ? props['data-testid'] : null}
        >
            {children}
        </div>
    );
};

export default PopoverDialog;
